exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".charges-table[data-v-333c4eee] {\n  width: 100%;\n}[dir] .charges-table[data-v-333c4eee] {\n  padding: 0;\n}\n", ""]);

// exports
